import { getHotkeyMenu, HOTKEY_TYPE, useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { ContextMenuPluginDependency } from '../../../dependency';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = ({ activeLayer, pickLayer, isImageEditor }: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();
    const layer = pickLayer || activeLayer;
    let disabled = !layer;

    if (isImageEditor && disabled) return null;
    if (isImageEditor && activeLayer) {
        disabled = framework.getBehavior(activeLayer)?.checkDisableCopy?.(activeLayer) ?? false;
    }

    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.copy),
        type: HOTKEY_TYPE.copy,
        desc: getHotkeyMenu(HOTKEY_TYPE.copy),
        onClick: () => {
            framework.getInstance(ContextMenuPluginDependency).onCopy();
        },
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 1,
    sort: 4,
    render,
} as IExportContextMenuItem;
